import type * as React from 'react';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import passwordResetPerformed, {
	type PasswordResetPerformedAction,
} from '@Application/Security/PasswordResets/Actions/passwordResetPerformed';
import passwordResetFailed, {
	type PasswordResetFailedAction,
} from '@Application/Security/PasswordResets/Actions/passwordResetFailed';
import type PerformPasswordReset from '@Application/Security/PasswordResets/Commands/PerformPasswordReset';
import FALLBACK_MESSAGES from '@Application/Security/TokenJourney/FALLBACK_MESSAGES';
import resolveFailureReason from '@Application/Security/TokenJourney/resolveFailureReason';
import parameters from '../../../parameters';

type Actions = PasswordResetPerformedAction | PasswordResetFailedAction;

export default (command: PerformPasswordReset) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// The route always answers 204: reading the response would throw on the nominal path.
			await post<void>(`${parameters.api.host}/api/password-resets/${command.token}`, command.toJSON());

			const action = passwordResetPerformed();
			dispatch(action);
			return action;
		} catch (error) {
			const extractedMessages = extractMessages(error);
			const reason = resolveFailureReason(error);
			const message = extractedMessages?.message ?? FALLBACK_MESSAGES.passwordResetGone;
			const action = passwordResetFailed(extractedMessages, reason, message);
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
